import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  ContextColorProvider,
  Tabs,
  TabList,
  Tab
} from '@warrenbrasil/nebraska-web';
import { Hero, HeroContainer } from '@/modules/common/components/Hero';
import { Header } from './components/Header';
import { BackButton } from '@/modules/common/components/buttons';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { Performance } from './components/Performance';
import { Allocation } from './components/Allocation';
import { Orders } from './components/Orders';
import { About } from './components/About';

import { getPortfolioV2, Portfolio } from '@/modules/wealth/services/portfolio';
import { IndexPortfolioTabsIndexes } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPortfolio',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isLoading = ref(false);
const hasError = ref(false);
const portfolioDetails = ref<Portfolio | null>(null);
const currentTabIndex = ref(IndexPortfolioTabsIndexes.Performance);

const portfolioId = computed(() => {
  const { portfolioId } = route.params;

  return portfolioId;
});

provide('portfolioId', portfolioId);

const portfolioImages = computed(() => {
  return {
    full: portfolioDetails.value?.image.full,
    regular: portfolioDetails.value?.image.regular,
    small: portfolioDetails.value?.image.small
  };
});

const getPortfolioDetails = async () => {
  isLoading.value = true;
  hasError.value = false;

  try {
    const portfolio = await getPortfolioV2(portfolioId.value);
    portfolioDetails.value = portfolio;
  } catch (error) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
};

provide('refreshPortfolioDetails', getPortfolioDetails);

const handleGoBackClick = () => {
  router.replace({ name: 'wealth' });
};

const onChangeTab = (selectedTabIndex: IndexPortfolioTabsIndexes) => {
  currentTabIndex.value = selectedTabIndex;
};

onMounted(async () => {
  await getPortfolioDetails();
});

return { __sfc: true,route, router, isLoading, hasError, portfolioDetails, currentTabIndex, portfolioId, portfolioImages, getPortfolioDetails, handleGoBackClick, onChangeTab, NavBar, ContextColorProvider, Tabs, TabList, Tab, Hero, HeroContainer, Header, BackButton, ShowMoneyToggleButton, Performance, Allocation, Orders, About, IndexPortfolioTabsIndexes }
}

})